/**
 * Format a count for display, handling loading state.
 * Shows "—" when count is null (loading), otherwise shows "X item(s)".
 *
 * @param {number|null} count - The count value (null = loading/not yet fetched)
 * @param {string} singular - Singular form of the item (e.g., "memory")
 * @param {string} plural - Plural form of the item (e.g., "memories")
 * @returns {string} Formatted string like "5 memories" or "—" if loading
 *
 * @example
 * formatCount(null, "memory", "memories") // "—"
 * formatCount(0, "memory", "memories")    // "0 memories"
 * formatCount(1, "memory", "memories")    // "1 memory"
 * formatCount(5, "memory", "memories")    // "5 memories"
 */
export function formatCount(count, singular, plural) {
  if (count === null || count === undefined) return "—";
  return `${count} ${count === 1 ? singular : plural}`;
}
